import { Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ProductService } from '../../../services';
import { ModalTransferModel } from '../../../models/modal-transfer.model';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-product-preview-modal',
  templateUrl: './product-preview-modal.component.html',
  styleUrl: './product-preview-modal.component.scss'
})
export class ProductPreviewModalComponent implements OnInit {
  @Input() reference: ModalTransferModel;
  selectedImage;
  model;
  cnetError: boolean;
  @Input() set open(open: boolean) {
    this._open = open;
  }
  get open(): boolean {
    return this._open;
  }
  private _open: boolean;

  @Output() modalClose = new EventEmitter();

  constructor(private readonly prodSrv: ProductService, private translate: TranslateService,
    public renderer: Renderer2, @Inject(DOCUMENT) private _document: Document) {}

  ngOnInit() {
    const data = this.reference.object;
    this.prodSrv.getProductVersion(data?.id, data?.currency, data?.language).subscribe(
      data => this.onGetProduct(data),
      err => this.onError(err)
    );
  }

  onGetProduct(data): void {
    this.model = data['result'];
    this.selectedImage = this.model.images ? this.model.images[0] : '';
    if (this.model.isCNETProduct) {
      this.cnetError = false;
      this.loadCNet();
    }
  }

  loadCNet() {
    const lang = this.translate.currentLang;
    const sc = this.renderer.createElement('script');
    sc.type = 'text/javascript';
    sc.text = "var ccs_cc_args = ccs_cc_args || [];"
      + "ccs_cc_args.push(['cpn', '20']);"
      + `ccs_cc_args.push(['mf', '${this.model.syndicateContentManufacture}']);`
      + `ccs_cc_args.push(['pn', '${this.model.purchaseSku}']);`

      + "ccs_cc_args.push(['upcean', 'UPC_EAN_CODE']);"
      + "ccs_cc_args.push(['ccid', 'CATALOG_CODE']);"
      + `ccs_cc_args.push(['lang', '${lang}']);`
      + `ccs_cc_args.push(['market', '${lang}']);`
      + "(function () {"
      + `  var o = ccs_cc_args; o.push(['_SKey', '${this.model.syndicateContentKey}']); o.push(['_ZoneId', '${this.model.syndicateContentZoneId}']);`
      + "  var sc = document.createElement('script'); sc.type = 'text/javascript'; sc.async = true;"
      + `  sc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + '${this.model.syndicateContentUrl}';`
      + "  var n = document.getElementsByTagName('script')[0]; n.parentNode.insertBefore(sc, n);"
      + "})();"
    var tag = this._document.getElementById("cnetTag");
    if (tag) this.renderer.appendChild(tag, sc);
    // 4. Fallback: Handle script load failure
    sc.onerror = () => {
      console.error('Failed to load CNET script');
      this.cnetError = true;
    };

      setTimeout(() => {
        const container = document.getElementById('cnetTag');
        if (container) {
          const hasContent = container.innerHTML.trim().length > 0;
          const isVisible = container.offsetHeight > 0 && container.offsetWidth > 0;

          if (!hasContent || !isVisible) {
            console.warn('Script loaded, but widget content is missing or invisible');
            this.cnetError = true;
            // You can trigger fallback logic here
          } else {
            this.cnetError = false;
            console.log('CNET widget rendered successfully');
          }
        }
      }, 2000);
  }

  onError(err) {
    console.log(err);
  }

  close() {
    this.open = false;
    this.modalClose.emit(false);
  }
}
